import React from "react";
import propTypes from "prop-types";
import { Route, Redirect } from "react-router-dom";

const PrivateRoute = ({ component, exact = false, path, authenticated }) => (
  <>
  <Route
    exact={exact}
    path={path}
    render={(props) =>
      authenticated ? (
        React.createElement(component, props)
      ) : (
        <Redirect
          to={{
            pathname: "/",
            state: { from: props.location },
          }}
        />
      )
    }
  />
  </>
);

PrivateRoute.propTypes = {
  component: propTypes.oneOfType([propTypes.object, propTypes.func]).isRequired,
  exact: propTypes.bool,
  path: propTypes.oneOfType([
    propTypes.object,
    propTypes.array,
    propTypes.string,
  ]).isRequired,
  authenticated: propTypes.bool.isRequired,
  location: propTypes.object,
};

export default PrivateRoute;
